import { useState } from 'preact/hooks'
import { FieldLabel } from './FieldLabel'

export const FieldText = ({ type = '', name, required, value, label, onChange, onInput, readOnly, pattern, placeholder, autoComplete = null, error, inputMode = null, maxLength = null }) => {
  const [isFocused, setIsFocused] = useState(false)
  return (
    <div className={'flex w-full flex-col gap-2'}>
      <FieldLabel {...{ label, hasInput: !!value, required }} />
      <div
        className={`relative overflow-hidden rounded-default border border-solid border-neutrals-tertiary-grey bg-primary-white transition-colors
        ${error ? 'border-system-error' : isFocused || !!value ? 'border-2 border-secondary-green' : 'border-neutrals-tertiary-grey'}`}
      >
        <input
          onFocus={() => {
            setIsFocused(true)
          }}
          onBlur={() => {
            setIsFocused(false)
          }}
          className={
            'min-h-12 w-full border-none px-4 read-only:cursor-default read-only:text-neutrals-secondary-grey read-only:opacity-60'
          }
          type={type}
          readOnly={readOnly}
          pattern={pattern}
          name={name}
          required={required}
          value={value}
          onChange={onChange}
          {...(onInput && { onInput })}
          placeholder={placeholder}
          {...(autoComplete && { autoComplete })}
          {...(inputMode && { inputMode })}
          {...(maxLength && { maxLength })}
        />

      </div>
      {error && <div className={'paragraph-sm text-system-error font-medium'}>{error}</div>}
      {/* <FieldBanner
        props={{
          icon: 'information-xs',
          content: 'This is a test input test '
        }}
      /> */}
    </div>
  )
}
